import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

/**
 * Generated class for the MenuPartialSharePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-combo-partial-share',
    templateUrl: 'combo-partial-share.html',
})
export class ComboPartialSharePage {
    @Input() color: string;

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {
    }
    
}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-list/combo-partial-share/combo-partial-share.ts